import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CommonExplainModule } from '../../../../common-explain/common-explain.module';
import { LibraryHealthVariant } from '../library-health-banner/library-health-banner.component';

@Component({
  selector: 'app-library-onboarding-card',
  standalone: true,
  imports: [CommonModule, TranslateModule, CommonExplainModule],
  templateUrl: './library-onboarding-card.component.html',
  styleUrls: ['./library-onboarding-card.component.scss'],
})
export class LibraryOnboardingCardComponent {
  @Input() variant: LibraryHealthVariant = 'low';
  @Input() disabled = false;

  @Output() goToLibrary = new EventEmitter<void>();
  @Output() later = new EventEmitter<void>();
}
